import { createFileRoute } from "@tanstack/react-router";
import LinksTableContainer from "../components/LinksTableContainer";

export const Route = createFileRoute("/links")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div>
      <LinksTableContainer />
    </div>
  );
}
